module.exports = __webpack_public_path__ + "static/media/ic_aadhaar_handy.82023015.svg";